import {FaInstagram} from "react-icons/all";

export const DETAILS = {
    name: "فروشگاه Night Wolf",
    fullName: "ابتکار کاوشگران البرز",
    footerName: "فروشگاه Night Wolf",
    description: "",
    shortAbout: "فروشگاه Night Wolf عرضه کننده انواع دوربین مداربسته، انواع سیستم های حفاظتی و نظارتی اماکن، ادارات و منازل می باشد. گروه فنی و مهندسی Night Wolf ارائه دهنده ی بهترین مدل های دوربین مداربسته از برند های معتبری از جمله داهوا و هایکویژن و برایتون و برند تخصصی Night Wolf به همراه پکیج های آماده ی دوربین مداربسته، مناسب برای کاربری های مختلف. همچنین شما میتوانید در صورت نیاز به نصب دوربین مداربسته در هنگام سفارش محصول با کارشناسان ما برای نصب محصول خود مشاوره ای داشته باشید.",
    veryShortAbout: "",
    link: "https://gmkalborz.com",
    mobileSell: ["02691095456", "09198142126"],
    mobileSoSell: ["09193614256", "02634824359"],
    email: [],
    postalCode: [],
    address: "کرج کمالشهر - خیابان شهید بهشتی - جنب فجر ۱۵ - برج توحید - طبقه سوم واحد ۷",
    supportDescription: "",
    workingHours: ["خدمات پس از فروش 9 صبح الی 22 شب", "فروش 8 صبح الی 9 شب", " 24 ساعته"],
    mapIframeSrc: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4718.965657519575!2d50.870016342807446!3d35.86567461323666!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8dbb0049ed46ed%3A0xc527e4ff7fb47eab!2z2qnYp9mI2LTar9ix2KfZhiDYp9mE2KjYsdiyINiv2YjYsdio24zZhiDZhdiv2KfYsdio2LPYqtmH!5e0!3m2!1sfa!2s!4v1731739692691!5m2!1sfa!2s",
    socialMedia: [
        {
            title: 'واتس اپ',
            value: '09198142126',
            name: 'whatsapp',
            link: 'https://api.whatsapp.com/send/?phone=989198142126&text&app_absent=0',
            icon: <i className="lab la-whatsapp"/>,
            isPrimary: true
        },
        {
            title: 'تلگرام',
            value: 'gmkalborz',
            name: 'telegram',
            link: 'https://t.me/gmkalborz',
            icon: <i className="lab la-telegram-plane"/>,
            isPrimary: true
        },
        {
            title: 'اینستاگرام',
            value: 'gmkalborz',
            name: 'instagram',
            link: "https://instagram.com/gmkalborz",
            icon: <FaInstagram/>,
            isPrimary: true
        },
        /*{
                    title: 'ایتا',
                    value: '09357195494',
                    name: 'eitaa',
                    link: 'https://eitaa.com/09357195494',
                    icon: <img src={eitaaIcon} alt='ایتا'/>,
                    isPrimary: false
                }
        {
            title: 'ایمیل',
            value: 'Volvotak@gmail.com',
            name: 'email',
            link: 'mailto:Volvotak@gmail.com',
            icon: <i className="las la-envelope"></i>,
            isPrimary: true
        },
        {
            title: 'تس',
            value: '09133377432',
            name: 'phone',
            link: 'tel:989133377432',
            icon: <PhoneCall/>,
            isPrimary: true
        },
                /*{
                    title: 'آپارات',
                    value: 'Alo_aghsat',
                    name: 'aparat',
                    link: 'https://www.aparat.com/Alo_aghsat',
                    icon: <SiAparat size={25}/>,
                    isPrimary: true
                },
                {
                    title: 'تماس',
                    value: '02636634893',
                    name: 'phone',
                    link: 'tel:+982636634893',
                    icon: <PhoneCall/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09331074475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09332094475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09330324475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'ایتا',
                    value: '09331074475',
                    name: 'eitaa',
                    link: '',
                    icon: <img src={eitaaIcon} alt='ایتا'/>,
                    isPrimary: false
                },*/
    ],
    services: [],
    brands: [
        /*{
            name: 'Apple',
            image: <img src={appleImage} alt='apple'/>,
        },*/
    ],
    enamad: {
        link: 'https://trustseal.enamad.ir/?id=292437&Code=J3imylLvwjEvSLt32DzA',
        src: 'https://trustseal.enamad.ir/logo.aspx?id=292437&Code=J3imylLvwjEvSLt32DzA',
        code: 'J3imylLvwjEvSLt32DzA'
    },
    "samandehiLink": "",
    "ZarinpalLink": "https://www.zarinpal.com/webservice/TrustCode"
}
